import { GrantedPermissionSet, GrantedPermissionSetResolver } from '../right.service';
import { OperationRights } from '../../app.right-definitions';

export class ProcessRightModel {

  public readonly create: GrantedPermissionSet;
  public readonly read: GrantedPermissionSet;
  public readonly update: GrantedPermissionSet;

  constructor(resolver: GrantedPermissionSetResolver) {
    this.create = resolver.of(OperationRights.PROCESS_CREATE);
    this.read = resolver.of(OperationRights.PROCESS_READ);
    this.update = resolver.of(OperationRights.PROCESS_UPDATE);
  }
}
